(ns manage.adset-decision-tree-page.view.side-panel.poi.core
  (:require ["@mui/material/Stack$default" :as Stack]
            ["react-hook-form" :as rhf]
            [common.form :as form]
            [common.queries :refer [use-query]]
            [common.resource.query.poi :as poi-query]
            [common.util :refer [str->int]]
            [manage.adset-decision-tree-page.view.side-panel.property-form
             :refer [get-property-field-name]]
            [uix.core :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(def ^:private time-constraint-options
  [{:label "Within" :value "within"}
   {:label "After" :value "no-sooner-than"}])

(defui poi-properties [{{:keys [control]} :form-control
                        :keys [property]}]
  (let [{:keys [advertiser-id]} (use-subscribe [:url-context])
        {:keys [data isFetching]} (use-query (poi-query/selector-options-query
                                              {:advertiser-id advertiser-id}))
        param-field-name (partial get-property-field-name property 0 :param)
        open-status-field (param-field-name :open-status)
        open-status (rhf/useWatch #js {:name open-status-field :control control})
        time-constraint (rhf/useWatch #js {:name (param-field-name :time-constraint) :control control})]
    ($ Stack {:spacing 2}
       ($ form/autocomplete-field
          {:name (param-field-name :selector-id)
           :control control
           :label "Selector"
           :field-props {:size "small"
                         :options data
                         :loading isFetching}})
       ($ form/form-text-field
          {:name (param-field-name :max-radius-km)
           :control control
           :label "Max radius (km)"
           :field-props {:size "small"
                         :type "number"
                         :required true}
           :on-change-fn str->int})
       ($ form/form-text-field
          {:name (param-field-name :min-radius-km)
           :control control
           :label "Min radius (km)"
           :field-props {:size "small"
                         :type "number"}
           :on-change-fn str->int})
       ($ form/autocomplete-field
          {:name open-status-field
           :control control
           :label "Opening status"
           :field-props {:size "small"
                         :clearable? true
                         :options [{:label "Open" :value "open"}
                                   {:label "Closed" :value "closed"}]}})
       (when open-status
         ($ :<>
            ($ form/autocomplete-field
               {:name (param-field-name :time-constraint)
                :control control
                :label (if (= open-status "open")
                         "Will close"
                         "Will open")
                :field-props {:size "small"
                              :clearable? true
                              :options time-constraint-options}})
            (when time-constraint
              ($ form/form-text-field
                 {:name (param-field-name :time-constraint-minutes)
                  :control control
                  :label "Minutes"
                  :field-props {:size "small"
                                :type "number"}
                  :on-change-fn str->int})))))))
